module.exports = "/_next/static/images/Sources@2x-272ac7c6d538ea379e62c6c51731f07d.webp";